<template>
    <div style="padding: 10px;color: white;">
        <el-drawer title="选择年份" :visible.sync="drawer" direction="ttb" style="color: black;">
            <div style="padding: 10px 0;background-color: #f5f5f5;margin-top: 10px;text-align: center;"
                 v-for="(item,index) in yearList" :key="index" @click="clickYear(item)">
                {{item}}
            </div>
        </el-drawer>
        <div ref="topCon"
             style="position: fixed;top: 0;left: 0;right: 0;background-color: white;text-align: center;padding: 10px;">
            <div @click="drawer = true"
                 style="padding: 10px;font-size: 16px;text-align: center;background: linear-gradient(to left, #75d8f7, #a9e7da);margin: auto;width: 80px;border-radius: 6px;">
                {{chooseYear?chooseYear:'请选择年份'}}
            </div>
            <div
                style="display: flex;align-items: center;justify-content: center;margin-top: 10px;margin-left: 6%;margin-right: 6%;">
                <div style="width: 100%;">
                    <el-input class="aa" placeholder="请输入身份证号/参赛号" clearable prefix-icon="el-icon-search"
                              v-model="inputValue" style="width: 100%;">
                    </el-input>
                </div>
                <div @click="search"
                     style="width: 60px;background: linear-gradient(to left, #75d8f7, #a9e7da);margin-left: 5px;padding: 3px 6px;border-radius: 6px;">
                    搜索
                </div>
            </div>
        </div>
        <div :style="`margin-top: ${topHeight}px;`">
            <div v-if="honourList.length>0">
                <div v-for="(item,index) in honourList" :key="index" style="margin: 10px;background: linear-gradient(to left, #75d8f7, #a9e7da);padding: 10px;
    border-radius: 8px;">
                    <div>姓名：{{item.userInfo.nickName}}</div>
                    <div>比赛地区：{{item.personalInfo.province}}/{{item.personalInfo.city}}/{{item.personalInfo.area}}</div>
                    <div>所属组别：{{item.userInfo.grade}}</div>
                    <div>分组：{{item.matchName}}</div>
                    <div>参赛编号：{{item.matchNo}}</div>
                    <!-- <div>证书编号：{{item.matchNo}}</div> -->
                    <div>奖项等级：{{item.matchHonour}}</div>
                    <div>状态：未打印</div>
                </div>
            </div>
            <div v-else style="text-align: center;">
                <img src="https://www.nychkc.com/home/img/other.868f2dd.png"
                     style="width: 274px;height: 174px;margin: 50px auto 0;" />
                <div style="font-size: 14px;color: #969696;margin-top: 20px;margin-bottom: 290px;">
                    暂无奖项与成绩记录哟~</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    selectHonourList
} from '@/api/inter.js'
export default {
    name: "SelectPage",
    data() {
        return {
            inputValue: '',
            topHeight: 0,
            drawer: false,
            yearList: [2024, 2023],
            chooseYear: null,
            honourList: []
        }
    },
    mounted() {
        this.topHeight = this.$refs.topCon.offsetHeight;
        selectHonourList({
            pageNum: 1,
            pageSize: 8
        }).then(res => {
            this.honourList = res.rows
        })
    },
    methods: {
        search() {
            if (!this.chooseYear) {
                this.$message({
                    message: '请选择日期查询',
                    type: 'info',
                    duration: 600
                })
                return
            }
            if (!this.inputValue) {
                this.$message({
                    message: '请输入内容搜索',
                    type: 'info',
                    duration: 600
                })
                return
            }
            if (this.chooseYear == 2023) {
                this.honourList = []
                return
            }
            let parme;
            if (this.inputValue.startsWith('NYCHKC')) {
                parme = {
                    matchNo: this.inputValue
                }
            } else {
                parme = {
                    idCardNum: this.inputValue
                }
            }
            selectHonourList(parme).then(res => {
                this.honourList = res.rows
            })
        },
        clickYear(item) {
            this.chooseYear = item
            this.drawer = false
        }
    }
}
</script>

<style>
.aa {
    height: 36px;
    border-radius: 30px;

    input {
        height: 36px;
        border-radius: 1.875rem;
        background-color: #f5f5f5;
        border: none;
    }

}
</style>
